import classnames from 'classnames';
import { Label, Text } from 'components';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { cn } from 'utils';

interface Props {
  className?: string;
  inputClassName?: string;
  label?: string;
  labelTooltip?: string;
  type?: 'text' | 'password' | 'email' | 'number';
  value: string;
  subText?: string;
  setValue?: Dispatch<SetStateAction<string>>;
  onChange?: (value: string) => void;
  placeholder?: string;
  errorMessage?: string;
}

const InputTextArea = ({
  className,
  inputClassName,
  type = 'text',
  label,
  labelTooltip,
  value,
  setValue,
  onChange,
  subText,
  placeholder,
  errorMessage
}: Props) => {
  function handleChange(e: ChangeEvent<HTMLTextAreaElement>) {
    const newValue = e.target.value;
    if (setValue) {
      setValue(newValue);
    }
    if (onChange) {
      onChange(newValue);
    }
  }

  return (
    <div className={classnames('flex w-full flex-col', className)}>
      {label && <Label label={label} htmlFor={label} labelTooltip={labelTooltip} />}
      <textarea
        id={label}
        className={cn(
          'border-border-primary',
          'relative w-full rounded border bg-transparent px-3 py-2 text-body2',
          inputClassName,
          { 'border-red-500': errorMessage }
        )}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
      {errorMessage && (
        <Text className="mt-2 !text-red-500" size="body2" weight="regular">
          {errorMessage}
        </Text>
      )}
      {subText && (
        <Text className="mt-2" size="small" weight="medium" color="secondary">
          {subText}
        </Text>
      )}
    </div>
  );
};

export default InputTextArea;